import { Deserializable } from './deserializable';
import { RatingtypeModel } from './ratingtype.model';
import { BaseModel } from './base.model';
import { LANGUAGES } from '../constants';
import { ExerciseversionModel } from './exerciseversion.model';
import { SlotModel } from './slot.model';
import { ResourceModel } from './resource.model';
import { AcOnlinetestModel } from './ac-onlinetest.model';
import { UserModel } from './user.model';
import { BusinessunitModel } from './businessunit.model';
import { TodoModel } from './todo.model';
import { LocationModel } from './location.model';

export enum TemplateType {
  Single = 'single',
  Group = 'group',
}

export const TEMPLATETYPES = {
  single: 'common.labels.single_ac',
  group: 'common.labels.group_ac',
}


export class TemplateModel extends BaseModel implements Deserializable {

  // columns
  name: string;
  status: string;
  type: TemplateType;
  language: string;
  template_category: string;
  documents_visible_observer: boolean; // tslint:disable-line: variable-name
  mailtext: string;
  onsite: boolean;
  virtual: boolean;
  breakafter: number | null;
  settings: any | null;
  prebriefing: boolean;
  planned_ac_amount?: number;
  tags: Array<string> = [];
  tags_required: boolean;
  tag_label: { [key: string]: string };
  tag_description: { [key: string]: string };
  short: boolean;
  starttimes: Array<string> = [];
  duration?: number;
  aireport_settings: { [key: string]: any };

  // relations
  ratingtype: RatingtypeModel = null;
  exerciseversions: Array<ExerciseversionModel> = [];
  slots: Array<SlotModel> = [];
  users: Array<UserModel> = [];
  resources: Array<ResourceModel> = [];
  onlinetests: Array<AcOnlinetestModel> = [];
  businessunits: Array<BusinessunitModel> = [];
  todos: Array<TodoModel> = [];
  locations: Array<LocationModel> = [];
  aireport: any;

  deserialize(input: any): this {
    Object.assign(this, input);
    // ratingtype
    if (this.ratingtype !== null && this.ratingtype !== undefined) {
      this.ratingtype = new RatingtypeModel().deserialize(this.ratingtype);
    }
    // exerciseversions
    let exerciseversions = null;
    if (this.exerciseversions !== null && this.exerciseversions !== undefined) {
      exerciseversions = [];
      this.exerciseversions.forEach((exerciseversion: ExerciseversionModel) => {
        exerciseversions.push(new ExerciseversionModel().deserialize(exerciseversion));
      });
    }
    this.exerciseversions = exerciseversions;
    // slots
    let slots = null;
    if (this.slots !== null && this.slots !== undefined) {
      slots = [];
      this.slots.forEach((slot: SlotModel) => {
        slots.push(new SlotModel().deserialize(slot));
      });
    }
    this.slots = slots;
    // users
    let users = null;
    if (this.users !== null && this.users !== undefined) {
      users = [];
      this.users.forEach((user: UserModel) => {
        users.push(new UserModel().deserialize(user));
      });
    }
    this.users = users;
    // onlinetests
    let onlinetests = null;
    if (this.onlinetests !== null && this.onlinetests !== undefined) {
      onlinetests = [];
      this.onlinetests.forEach((onlinetest: AcOnlinetestModel) => {
        onlinetests.push(new AcOnlinetestModel().deserialize(onlinetest));
      });
    }
    this.onlinetests = onlinetests;
    // resources
    let resources = null;
    if (this.resources !== null && this.resources !== undefined) {
      resources = [];
      this.resources.forEach((resource: ResourceModel) => {
        resources.push(new ResourceModel().deserialize(resource));
      });
    }
    this.resources = resources;
    // businessunits
    let businessunits = null;
    if (this.businessunits !== null && this.businessunits !== undefined) {
      businessunits = [];
      this.businessunits.forEach((businessunit: BusinessunitModel) => {
        businessunits.push(new BusinessunitModel().deserialize(businessunit));
      });
    }
    this.businessunits = businessunits;
    // locations
    let locations = null;
    if (this.locations !== null && this.locations !== undefined) {
      locations = [];
      this.locations.forEach((location: LocationModel) => {
        locations.push(new LocationModel().deserialize(location));
      });
    }
    this.locations = locations;
    // todos
    this.todos = this.todos?.map((todo: any) => new TodoModel().deserialize(todo)) || null;
    return this;
  }

  public get is_ac(): boolean {
    return this.status !== 'template' && this.status !== 'inactive';
  }

  public get is_template(): boolean {
    return this.status === 'template';
  }

  public get ratingtype_name(): string {
    return (this.ratingtype !== null && this.ratingtype?.loaded === true) ? this.ratingtype.getLang('name', 'DE') : '';
  }

  public get name_language(): string {
    return this.name + ' (' + this.language + ')';
  }

  public getLanguageName(): string {
    return (this.language) ? LANGUAGES[this.language] : '';
  }

  public hasPlannedAcs(): boolean {
    return this.is_template && this.planned_ac_amount > 0;
  }

  public isSingleAc(): boolean {
    return this.type === TemplateType.Single;
  }

  public isGroupAc(): boolean {
    return this.type === TemplateType.Group;
  }

  public isShort(): boolean {
    return this.short === true;
  }

  public isLong(): boolean {
    return !this.isShort();
  }

  public shouldShowInheritDialog(mode: string = 'template'): boolean {
    return mode === 'template' && this.is_template && this.hasPlannedAcs();
  }

}
